import {createTable, RenderingPresetType, TableHeaderSpec} from "../../../../../components/table/CreateTable.tsx";
import {SharedDocument} from "./SharedDocument.ts";
import prettyBytes from "pretty-bytes";
import {ShieldCheckIcon} from "@heroicons/react/24/solid/index";
import AIToolTip from "../../../../../components/general/AIToolTip.tsx";
import type {DocumentDirection} from '../../../../../generated/enums.ts';

interface Props {
    data: Array<SharedDocument>,
    onDocumentClick?: (document: SharedDocument) => void,
    allowFullRowClick?: boolean,
}

const documentDirectionLabels: Record<DocumentDirection, string> = {
    purchase_invoice: 'Inkoopfactuur / bon',
    sales_invoice: 'Verkoopfactuur',
    other: 'Overig',
};

export function SharedDocumentsTable({data, onDocumentClick, allowFullRowClick = false}: Props) {

    const tableSpec: TableHeaderSpec<SharedDocument> = {
        title: `${data.length} files`,
        columns: [
            {
                name: 'Naam',
                field: 'file_name',
                customRender(row: SharedDocument) {
                    return <span>{row.file_name.slice(42)}</span>
                },
                style: {
                    widthMultiplier: 2
                }
            },
            {
                name: 'Type',
                field: 'document_direction',
                customRender: (row: SharedDocument) => {
                    return <span className={'inline-flex items-center gap-2'}>{documentDirectionLabels[row.document_direction] || row.document_direction || '-'}
                        {(row.shared_via === 'email' && row.document_direction) && <AIToolTip text={'This is detected using Transaction Intelligence'}/>}
                    </span>
                },
                style: {
                    widthMultiplier: 1
                }
            },
            {
                name: 'Grootte',
                field: 'size',
                customRender: (row: SharedDocument) => {
                    return <span>{prettyBytes(row.size)}</span>
                },
                style: {
                    widthMultiplier: 0.5
                }
            },
            {
                name: 'Geüpload op',
                field: 'created_at',
                renderingPreset: RenderingPresetType.DateTime
            },
            {
                name: 'Veiligheid',
                field: '',
                customRender(row: SharedDocument) {
                    return <span className="inline-flex items-center gap-2"><ShieldCheckIcon className="w-6 h-6"/> Encrypted</span>
                }
            },
        ],
        onEmptyRender: () => <>
            <span className="text-gray-500">Geen documenten. Sleep of click op de dropzone boven om documenten te delen.</span>
        </>,

        options: {
            disableTopPaginationWidget: true,
            allowFullRowClick: allowFullRowClick,
        },
        onRowClick: onDocumentClick || (() => {}),
    }

    const TableComponent = createTable<SharedDocument>(data, tableSpec)

    return (
        <>
            {TableComponent()}
        </>
    )
}
